import OBase from './OBase';
import * as Geometry from '../geometry';

export default class Distance extends OBase {
  update () {
    let aTree = this.getVector3Input('Point A', false);
    let bTree = this.getVector3Input('Point B', false);

    let output = this.getGenericObjectOutput('Distance');

    let dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(aTree);
    dataTrees.push(bTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let aval = outDataTrees[0].branches[i][j];
        let bval = outDataTrees[1].branches[i][j];
        let dist = aval.distanceTo(bval);
        outTree.add(dist, outDataTrees[0].paths[i]);
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Distance.js